export default "__VITE_ASSET__9SFzhRMu__"